var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1873 15.2982L18.0206 22.1675L14.8127 19.0926C14.3979 18.6951 13.7259 18.6951 13.3111 19.0926C12.8963 19.4902 12.8963 20.1344 13.3111 20.5319L17.2698 24.3264C17.4763 24.5244 17.7494 24.625 18.0206 24.625C18.2919 24.625 18.5632 24.526 18.7714 24.3264L26.6889 16.7375C27.1037 16.3399 27.1037 15.6957 26.6889 15.2982C26.2741 14.9006 25.6021 14.9006 25.1873 15.2982Z",
    fill: "#762B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectMeditation);
export default __webpack_public_path__ + "static/media/selectMeditation.29cd470da902bf45405a78373ddb406f.svg";
export { ForwardRef as ReactComponent };